import { ReactElement } from "react";
import classNames from "classnames";
import { AppIcon } from "client/Components";
import { UserRequestItemClientModel } from "client/Api/UserRequests/manageUserRequests";
import styles from "./RequestedItem.module.less";
import { getReactColorAttributes } from "client_legacy/ndaw/appColor";

export type RequestedItemProps = {
	item: UserRequestItemClientModel;
	isSelected?: boolean;
};

export const RequestedItem = (props: RequestedItemProps): ReactElement => {
	const {
		item,
		isSelected = false
	} = props;

	const { colorClass, colorStyle } = getReactColorAttributes(item.color);

	return (
		<div className={styles.root}>
			<span className={styles.icon}>
				<span
					className={classNames(
						styles.appIcon,
						colorClass,
						{
							[styles.appIcon_selected]: isSelected
						}
					)}
					style={colorStyle}
				>
					<AppIcon value={item.icon} color="inherit" />
				</span>
			</span>
			<span className={styles.name}>
				{item.name}
			</span>
		</div>
	);
};
RequestedItem.displayName = "RequestedItem";